import React from "react";
import Outcomes from "../Event/Outcomes";
import type { Event, EventMarket } from "hooks/firestore/betting/useBetting";
import type { ToggleSelectionPayload } from "hooks/firestore/betting/types";
import * as styles from "./MarketGroup.module.scss";
import type { OddsFormat } from "types/BetTypes";
import type { OutcomesWithMarketType } from "./MarketGroup";

const OutcomesGroup = ({
  groupedMarkets,
  oddsFormat,
  toggleSelection,
  selections,
  event,
  isOutright,
  fullWidth,
}: {
  groupedMarkets: EventMarket[];
  oddsFormat: OddsFormat;
  toggleSelection: (selection: ToggleSelectionPayload) => void;
  selections: string[];
  event: Event;
  isOutright?: boolean;
  fullWidth?: boolean;
}) => {
  // This is a temporary fix, unless we can have a solution in the API where it joins the markets
  const outcomes = groupedMarkets.reduce((acc, market) => {
    // add market into outcomes
    const outcomes = Object.entries(market.outcomes).reduce(
      (acc, [outcomeId, outcome]) => {
        acc[outcomeId] = {
          ...outcome,
          id: outcomeId,
          marketId: market.id,
          market: {
            id: market.id,
            name: market.name,
            bettingType: market.bettingType,
            status: market.status,
            category: market.category,
            marketType: market.marketType,
            hasPromotionalMarkets: market.hasPromotionalMarkets,
          },
        };
        return acc;
      },
      {},
    );

    return {
      ...acc,
      ...outcomes,
    };
  }, {} as OutcomesWithMarketType);

  return (
    <Outcomes
      oddsFormat={oddsFormat}
      eventId={event.eventId}
      outcomes={outcomes as any}
      competitors={event.competitors}
      toggleSelection={toggleSelection}
      isOutright={isOutright}
      selections={selections}
      fullWidth={fullWidth}
    />
  );
};

export default OutcomesGroup;
